import React from 'react';
import GoogleMapReact from 'google-map-react';
import Firebase from 'firebase';

export default class main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            center: { lat: -33.4164986, lng: -70.6007971 },
            zoom: 11,
            displayCheckIn: "none",
            displayCheckOut: "none",
            displayLocal: "none"
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.local) {
            this.setState({
                local: nextProps.local.local,
                local_lat: parseFloat(nextProps.local.Lat),
                local_lon: parseFloat(nextProps.local.Long)
            })
        }
    }

    render() {
        return (
            <div style={{ width: '100%', height: '285px' }}>
                <GoogleMapReact
                    defaultCenter={this.state.center}
                    defaultZoom={this.state.zoom}
                    onChildClick={(e) => { }}
                >
                    {
                        this.props.checkIn ?
                            <div
                                onMouseOver={(e) => { this.setState({ displayCheckIn: "" }) }}
                                onMouseOut={(e) => { this.setState({ displayCheckIn: "none" }) }}
                                lat={this.props.checkIn.global.gps.lat}
                                lng={this.props.checkIn.global.gps.lon}>
                                <i className="fa fa-map-marker" aria-hidden="true" style={{ fontSize: "30px", cursor: "pointer", color: "#4dbd74" }}></i>
                                <span style={{
                                    position: "absolute",
                                    top: "-15px",
                                    background: "#FFF",
                                    left: "13px",
                                    width: "80px",
                                    padding: "3px",
                                    border: "1px solid #111",
                                    borderRadius: "9px",
                                    display: this.state.displayCheckIn,
                                    zIndex :"10"
                                }}  >entrada</span>
                            </div>
                            :
                            ""
                    }
                    {
                        this.props.checkOut ?
                            <div
                                onMouseOver={(e) => { this.setState({ displayCheckOut: "" }) }}
                                onMouseOut={(e) => { this.setState({ displayCheckOut: "none" }) }}
                                lat={this.props.checkOut.global.gps.lat}
                                lng={this.props.checkOut.global.gps.lon}>
                                <i className="fa fa-map-marker" aria-hidden="true" style={{ fontSize: "30px", cursor: "pointer", color: "#eb6651" }}></i>
                                <span style={{
                                    position: "absolute",
                                    top: "-15px",
                                    background: "#FFF",
                                    left: "13px",
                                    width: "80px",
                                    padding: "3px",
                                    border: "1px solid #111",
                                    borderRadius: "9px",
                                    display: this.state.displayCheckOut,
                                    zIndex :"10"
                                }}  >salida</span>
                            </div>
                            :
                            ""
                    }
                    {
                        this.state.local && this.state.local_lon && this.state.local_lat ?
                            <div
                                onMouseOver={(e) => { this.setState({ displayLocal: "" }) }}
                                onMouseOut={(e) => { this.setState({ displayLocal: "none" }) }}
                                lat={this.state.local_lat}
                                lng={this.state.local_lon}>
                                <i className="fa fa-home" aria-hidden="true" style={{ fontSize: "30px", cursor: "pointer" }}></i>
                                <span style={{
                                    position: "absolute",
                                    top: "-23px",
                                    background: "#FFF",
                                    left: "30px",
                                    width: "80px",
                                    padding: "3px",
                                    border: "1px solid #111",
                                    borderRadius: "9px",
                                    display: this.state.displayLocal,
                                    zIndex :"10"
                                }}  >{this.state.local}</span>
                            </div>
                            :
                            ""
                    }
                </GoogleMapReact>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/control_de_asistencia/mapa.js